import { useState } from "react";
import type { Article } from "@/mocks/news";
import ArticleCard from "@/components/feature/ArticleCard";

interface TopicFeedProps {
  title: string;
  subtitle?: string;
  categories: { slug: string; name: string }[];
  articles: Article[];
}

export default function TopicFeed({ title, subtitle, categories, articles }: TopicFeedProps) {
  const [active, setActive] = useState<string>(categories[0]?.slug ?? "");

  const list = articles.filter((item) => item.category === active);

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6 md:mb-8">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-label text-primary-600 mb-2">
            <span className="w-4 h-0.5 bg-primary-500 rounded-full"></span>
            分类精选
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-2 text-sm text-foreground-600 font-label max-w-2xl">{subtitle}</p>
          )}
        </div>
      </div>

      <div className="inline-flex flex-wrap gap-1 p-1 rounded-full bg-background-100 border border-background-200 mb-7">
        {categories.map((category) => (
          <button
            key={category.slug}
            type="button"
            onClick={() => setActive(category.slug)}
            className={`px-4 py-2 rounded-full text-sm font-label transition-colors cursor-pointer whitespace-nowrap ${
              active === category.slug
                ? "bg-primary-500 text-background-50"
                : "text-foreground-600 hover:bg-background-200"
            }`}
          >
            {category.name}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {list.slice(0, 4).map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>

      {list.length === 0 && (
        <p className="text-sm text-foreground-500 font-label py-8 text-center">
          该分类暂无内容，稍后再来看看。
        </p>
      )}
    </section>
  );
}